import { render, staticRenderFns } from "./AddTask.vue?vue&type=template&id=6f9edd6f&scoped=true"
import script from "./AddTask.vue?vue&type=script&lang=js"
export * from "./AddTask.vue?vue&type=script&lang=js"
import style0 from "./AddTask.vue?vue&type=style&index=0&id=6f9edd6f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9edd6f",
  null
  
)

export default component.exports